import * as AccordionWrapper from './AccordionWrapper'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/accordion' instead.
 */
export const Accordion = AccordionWrapper
